import React, { useState } from "react";
import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";
import { Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import WaitingForProgramming from "../../components/admin/programming/WaitingForProgramming";
import ProgrammingInProgress from "../../components/admin/programming/Programming";
import WaitingForCheck from "../../components/admin/programming/WaitingForCheck";
import Checking from "../../components/admin/programming/Checking";

const WAITING_FOR_PROGRAMMING_TAB = "WAITING_FOR_PROGRAMMING_TAB";
const PROGRAMMING_TAB = "PROGRAMMING_TAB";
const WAITING_FOR_CHECK_TAB = "WAITING_FOR_CHECK_TAB";
const CHECKING_TAB = "CHECKING_TAB";

const DEFAULT_TABS_TO_LOAD = [
  WAITING_FOR_PROGRAMMING_TAB,
  PROGRAMMING_TAB,
  WAITING_FOR_CHECK_TAB,
  CHECKING_TAB,
];

const ProgrammerDashboard = () => {
  const [reloadTabs, setReloadTabs] = useState(DEFAULT_TABS_TO_LOAD);
  const [waitingForProgrammingTotal, setWaitingForProgrammingTotal] =
    useState(0);
  const [programmingTotal, setProgrammingTotal] = useState(0);
  const [waitingForCheckTotal, setWaitingForCheckTotal] = useState(0);
  const [checkingTotal, setCheckingTotal] = useState(0);

  return (
    <Container fluid className="mb-4">
      <Header className="mb-3 ">
        <HeaderTitle className="d-flex flex-column align-items-start">
          <span className="col-12 px-0 col-lg-6 text-dark">
            Jobs In Programming
          </span>
        </HeaderTitle>
      </Header>
      <Row>
        <Card className="box-shadow-none border-left border-right mb-0 w-100">
          <CardHeader className="pb-0">
            <div className="h4 m-0">New Jobs</div>
          </CardHeader>
          <CardBody className="pt-0">
            <WaitingForProgramming
              setProgrammingTotal={setWaitingForProgrammingTotal}
              programmingTotal={waitingForProgrammingTotal}
              setReloadTabs={setReloadTabs}
              reloadTabs={reloadTabs}
              tabName={WAITING_FOR_PROGRAMMING_TAB}
            />
          </CardBody>
        </Card>
      </Row>
      <Row>
        <Card className="box-shadow-none border-left border-right mb-0 w-100">
          <CardHeader className="pb-0">
            <div className="h4 m-0">Programming in Progress</div>
          </CardHeader>
          <CardBody className="pt-0">
            <ProgrammingInProgress
              setProgrammingTotal={setProgrammingTotal}
              programmingTotal={programmingTotal}
              setReloadTabs={setReloadTabs}
              reloadTabs={reloadTabs}
              tabName={PROGRAMMING_TAB}
            />
          </CardBody>
        </Card>
      </Row>
      <Row>
        <Card className="box-shadow-none border-left border-right mb-0 w-100">
          <CardHeader className="pb-0">
            <div className="h4 m-0">Waiting for Check</div>
          </CardHeader>
          <CardBody className="pt-0">
            <WaitingForCheck
              setProgrammingTotal={setWaitingForCheckTotal}
              programmingTotal={waitingForCheckTotal}
              setReloadTabs={setReloadTabs}
              reloadTabs={reloadTabs}
              tabName={WAITING_FOR_CHECK_TAB}
            />
          </CardBody>
        </Card>
      </Row>
      <Row>
        <Card className="box-shadow-none border-left border-right mb-0 w-100">
          <CardHeader className="pb-0">
            <div className="h4 m-0">Checking Jobs</div>
          </CardHeader>
          <CardBody className="pt-0">
            <Checking
              setProgrammingTotal={setCheckingTotal}
              programmingTotal={checkingTotal}
              setReloadTabs={setReloadTabs}
              reloadTabs={reloadTabs}
              tabName={CHECKING_TAB}
            />
          </CardBody>
        </Card>
      </Row>
    </Container>
  );
};

export default ProgrammerDashboard;
